import actions from "./questionnaireActions";

export const initialState = {
  userID: null,
  questionnaires: [],
  ranking: [],
  prioritizedYesIndexes: [],
  currentQuestionnaire: null,
  currentStep: 1,
  isLoading: true,
};

const questionnaireReducer = (state, action) => {
  switch (action.type) {
    case actions.SET_QUESTIONNAIRE:
      return {
        ...state,
        questionnaires: action.payload.questionnaires,
        currentQuestionnaire: action.payload.currentQuestionnaire,
      };
    case actions.SAVE_CHOICE:
      //console.log("questionnaireReducer", action);
      return {
        ...state,
        questionnaires: action.payload,
      };
    case actions.ADD_RANKING:
      return {
        ...state,
        ranking: action.payload,
      };
    case actions.RESET:
      return initialState;
    case actions.CHANGE_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    case actions.LOAD_DATA:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    case actions.SET_PRIORITIZED_YES_INDEXES:
      return {
        ...state,
        prioritizedYesIndexes: action.payload,
      };
      case actions.REMOVE_RANKING_AND_INDEXES:
        return {
          ...state,
          ranking: [],
          prioritizedYesIndexes: [],
        };
    default:
      return state;
  }
};

export default questionnaireReducer;
